import { getCookie } from '../utils/cookies';
import {
  IUserProfile,
  IEngageOnboardingData,
  IRegistrationData,
  IActivateWithPassword,
  IRequestPasswordReset,
  IChangeEmail,
  IVerfiyEmailChange,
  IChangePassword,
  IDeleteAccount
} from '../types';

export interface IUserService {
  register(registrationData: IRegistrationData): Promise<Response>;
  getUserProfile(): Promise<Response>;
  updateUser(data: IUserProfile | IEngageOnboardingData): Promise<Response>;
  assignGroups(groupIds: string[]): Promise<Response>;
  getEngageOnboardingData(): Promise<Response>;
  exchangeActivationTokenForState(token: string): Promise<Response>;
  requestPasswordReset(data: IRequestPasswordReset): Promise<Response>;
  setPassword(data: IActivateWithPassword): Promise<Response>;
  changeEmail(data: IChangeEmail): Promise<Response>;
  verifyEmailChange(data: IVerfiyEmailChange): Promise<Response>;
  changePassword(data: IChangePassword): Promise<Response>;
  deleteAccount(data: IDeleteAccount): Promise<Response>;
}

export class UserService implements IUserService {
  baseUrl: string;

  constructor({ baseUrl }: { baseUrl: string }) {
    this.baseUrl = baseUrl;
  }

  async register(registrationData: IRegistrationData) {
    return await fetch(`${this.baseUrl}/register`, {
      method: 'POST',
      headers: new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify(registrationData)
    });
  }

  async getUserProfile(): Promise<Response> {
    const token = getCookie('enginuity-sp-token');
    return await fetch(`${this.baseUrl}`, {
      method: 'GET',
      headers: new Headers({
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      })
    });
  }

  async updateUser(
    data: IUserProfile | IEngageOnboardingData
  ): Promise<Response> {
    const token = getCookie('enginuity-sp-token');
    return await fetch(`${this.baseUrl}`, {
      method: 'POST',
      headers: new Headers({
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify(data)
    });
  }

  async assignGroups(groupIds: string[]): Promise<Response> {
    const token = getCookie('enginuity-sp-token');
    return await fetch(`${this.baseUrl}/groups`, {
      method: 'POST',
      headers: new Headers({
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify(groupIds.join(','))
    });
  }

  async getEngageOnboardingData(): Promise<Response> {
    return await fetch(`${this.baseUrl}/onboardingOptions`, {
      method: 'GET',
      headers: new Headers({
        Accept: 'application/json'
      })
    });
  }

  async exchangeActivationTokenForState(token: string): Promise<Response> {
    const url = `${this.baseUrl}/activate`;
    return await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        activationToken: token
      })
    });
  }

  async requestPasswordReset(data: IRequestPasswordReset): Promise<Response> {
    const url = `${this.baseUrl}/reset-password`;
    return await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
  }

  async setPassword(data: IActivateWithPassword): Promise<Response> {
    const url = `${this.baseUrl}/password`;
    return await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
  }

  async changeEmail(data: IChangeEmail): Promise<Response> {
    const token = getCookie('enginuity-sp-token');
    return await fetch(`${this.baseUrl}/changeEmail`, {
      method: 'POST',
      headers: new Headers({
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify(data)
    });
  }

  async verifyEmailChange(data: IVerfiyEmailChange): Promise<Response> {
    const token = getCookie('enginuity-sp-token');
    return await fetch(`${this.baseUrl}/verifyEmailChange`, {
      method: 'POST',
      headers: new Headers({
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify(data)
    });
  }

  async changePassword(data: IChangePassword): Promise<Response> {
    const token = getCookie('enginuity-sp-token');
    return await fetch(`${this.baseUrl}/changePassword`, {
      method: 'POST',
      headers: new Headers({
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify(data)
    });
  }

  async deleteAccount(data: IDeleteAccount): Promise<Response> {
    const token = getCookie('enginuity-sp-token');
    return await fetch(`${this.baseUrl}/deleteAccount`, {
      method: 'POST',
      headers: new Headers({
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify(data)
    });
  }
}
